
// 2.- este archivo es el componente que contiene cada pregunta individual para el examen

import React from 'react'

import { Radio, Space } from 'antd'
import usePreguntaExamen from '../hooks/examen/usePreguntaExamen'
import { DOMINIO_SERVIDOR } from '../api/url'
import { alias_examen } from '../data/datos'
import { useParams } from 'react-router-dom'

import audio_1 from '../assets/05_B_1.mp3'
import audio_2 from '../assets/06_B_2.mp3'
import audio_3 from '../assets/07_B_3.mp3'


const PreguntaExamen = ({ imagen, pregunta, respuestas, indice, pk_pregunta }) => {

    const { id:pk_materia } = useParams('id')

    const { respuestaSeleccionada, setRespuestaSeleccionada } = usePreguntaExamen(pk_pregunta, indice)

    var indice_audios = [ 1, 5, 8 ]
    var mostrarAudio = false

    // eslint-disable-next-line
    if ( indice_audios.includes( indice ) && pk_materia == 4 ) {
        mostrarAudio= true
    }


    const renderAudio = () => {
        if ( mostrarAudio ) {

            var audio_final;

            // eslint-disable-next-line
            if ( indice == 1 ) {
                audio_final = audio_1
                // eslint-disable-next-line
            } else if ( indice == 5 ) {
                audio_final = audio_2
                // eslint-disable-next-line
            } else if ( indice == 8 ) {
                audio_final = audio_3
            }

            return (
                <audio controls>
                    <source src={ audio_final } type="audio/mpeg" />
                    Tu navegador no soporta audios.
                </audio>
            )
        }
    }


    const renderImagen = () => {
        if ( imagen ) {
            return (
                <img
                    alt=''
                    src={ `${DOMINIO_SERVIDOR}/img/examen/${imagen}` }
                    className='img-responsiva'
                />
            )
        }
    }

    return (
        <div style={{ marginBottom: 80 }}>

            <p className='lead no-select' style={{ whiteSpace: 'pre-line', marginBottom: 30, fontWeight: 400 }}>
                { indice } .- { pregunta }
            </p>

            { renderAudio() }

            { renderImagen( imagen ) }
            <br/>

            <Radio.Group value={respuestaSeleccionada} onChange={e => setRespuestaSeleccionada(e.target.value) }>
                <Space direction="vertical">

                    {respuestas.map(r => {

                        let carpeta = alias_examen[ pk_materia ]
                        let nombre = `${indice}-${carpeta}-${r.letra}.png`

                        let src = `${DOMINIO_SERVIDOR}/img/examen/${carpeta}/${nombre}`

                        let id = indice + r.letra

                            // eslint-disable-next-line
                        if ( r.respuesta == ':imagen' && r.correcta == 0 ) {
                            return (
                                <Radio key={r.pk_respuestas} value={r.pk_respuestas} id={ id }>
                                    {r.letra} <img src={ src } className='img-responsiva' alt=''/>
                                </Radio>
                            );
                            // eslint-disable-next-line
                        } else if( r.respuesta == ':imagen' && r.correcta == 1 ) {
                            return (
                                <Radio key={r.pk_respuestas} value={r.pk_respuestas} id={ id }>
                                    {r.letra} <img src={ src } className='img-responsiva' alt=''/>
                                </Radio>
                            );
                        } else {
                            return (
                                <Radio key={r.pk_respuestas} value={r.pk_respuestas} id={ id }>
                                    <p className='no-select' style={{ fontSize: "1rem", fontWeight: 300 }}>
                                        {r.letra} .- {r.respuesta}
                                    </p>
                                </Radio>
                            );
                        }
                    } )}

                </Space>
            </Radio.Group>

        </div>
    )

}

export default PreguntaExamen
